import { useState } from "react";
import BASE_URL from "../Utilities/BASE_URL";
import { useTranslation } from "react-i18next";

const usePost = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const { i18n } = useTranslation();
  const postData = async (endpoint, postData, token) => {
    setIsLoading(true);
    setIsError(null);
    setData(null);

    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if token is provided
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(
        `${BASE_URL}/${i18n?.language}/${endpoint}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(postData),
          credentials: "include",
          mode: "cors",
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.log("API Error Response:", errorData);
        // Return the error data instead of throwing, so we can handle it in the component
        setIsError(errorData.message || "Server error");
        return errorData;
      }

      const result = await response.json();
      setData(result);
      return result;
    } catch (error) {
      console.log(error);
      setIsError(error.message || "An error occurred while posting data");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, isError, postData };
};

export default usePost;
